import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFox = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.75 5.04211L7.75 14.6347M14.75 9.44952V0.634705L0.75 9.44952M14.75 9.44952L7.75 14.6347M14.75 9.44952L0.75 0.634705L0.75 9.44952M0.75 9.44952L7.75 14.6347",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgFox;
